import Navbar from "./Navbar";
import React from "react";
import "./base.css";

export default function BaseLayout({ user, header, className, children }) {
  return (
    <React.Fragment>
      <Navbar />
      <main className={className + " min-h-screen bg-gray-200"}>{children}</main>
    </React.Fragment>
  );
}
